<template>
  <partner-products-section :title="$t('Most ordered')" :products="products" :loading="loading" :skeleton="false" />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import config from 'config'
import { curatedProducts } from '@vue-storefront/core/lib/catalogSearch'
import PartnerProductsSection from 'theme/components/theme/blocks/Partners/PartnerProductsSection'

export default {
  name: 'MostOrderedFromPartner',
  components: {
    PartnerProductsSection
  },
  data () {
    return {
      products: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters({ currentPartner: 'partners/getCurrentPartner' })
  },
  watch: {
    'currentPartner.code': {
      immediate: true,
      handler (code) {
        if (code) this.loadProducts()
      }
    }
  },
  methods: {
    ...mapActions({ productList: 'product/list' }),
    async loadProducts () {
      if (!this.currentPartner) {
        this.products = []
        return
      }
      // K2-3030: ranks the partner's own catalog by ES-side sum_score (ms-api's
      // Order\ScoreController, revenue over a trailing window - consolidated from what
      // used to be a separate sales_score field/cron, K2-3000) - deliberately a separate,
      // independent query (updateState: false) rather than sorting/slicing
      // PartnerView.vue's shared preloaded product list, since shop-mode partners only
      // preload 2 categories' worth of products there (size=12), not the full catalog - a
      // client-side sort/slice over that would silently be wrong for shop-mode partners.
      this.loading = true
      try {
        const resp = await this.productList({
          semanticFetch: () => curatedProducts({
            size: config.catalog.product.mostOrdered.limit,
            sort: 'sum_score:desc'
          }),
          updateState: false
        })
        this.products = (resp.items || []).filter(product => product.sum_score > 0)
      } catch (e) {
        this.products = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
